((Drupal, once) => {
  /**
   * Comportement pour mettre en gras le menu lors du scroll (Scroll Spy).
   */
  Drupal.behaviors.navigationScrollSpy = {
    attach(context) {
      const links = context.querySelectorAll('.sticky-nav a[href^="#"]');

      if (links.length === 0) {
        return;
      }
     
      const targetSelectors = Array.from(links)
        .map(link => link.getAttribute('href'))
        .filter(href => href !== '#')
        .join(', ');
        
      if (!targetSelectors) {
        return;
      }

      const rawTargets = context.querySelectorAll(targetSelectors);
      const targetsToObserve = once('scroll-spy-sections', rawTargets, context);

      if (targetsToObserve.length === 0) {
        return;
      }
      const options = {
        root: null,
        rootMargin: '-10% 0px -70% 0px',
        threshold: 0
      };

      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            // On nettoie la classe 'active' de tous les liens de ce menu
            links.forEach(link => link.classList.remove('active'));
            const activeId = entry.target.getAttribute('id');
            const activeLink = document.querySelector(`.sticky-nav a[href="#${activeId}"]`);
            
            if (activeLink) {
              activeLink.classList.add('active');
            }
          }
        });
      }, options);
      targetsToObserve.forEach(target => {
        observer.observe(target);
      });
    }
  };
})(Drupal, once);
